export default __webpack_public_path__ + "static/media/career-development.6ca23b9a.png";